<template>
  <div class="card" style="min-height: 200px">
    <div class="table-responsive">
      <table class="table">
        <thead>
        <tr>
          <th>Date</th>
          <th>Bill Number</th>
          <th class="text-right">Bill Amount</th>
          <th class="text-right">Paid Amount</th>
          <th class="text-right">Due Amount</th>
          <th>Party Name</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in sales_return" :key="i">
          <td> {{ item.date }}</td>
          <td> {{ item.bill_number }}</td>
          <td class="text-right"> {{ item.bill_amount }}</td>
          <td class="text-right"> {{ item.paid_amount }}</td>
          <td class="text-right"> {{ item.due_amount }}</td>
          <td> {{ item.party_name }}</td>
          <td>
            <button class="btn btn-secondary btn-sm"
                    @click="goToMushak67Print(item.id)"
                    style="cursor: pointer"
                    title="Mushak 6.7"
            >
              <i class="fas fa-print"></i>
            </button>
          </td>
        </tr>

        </tbody>
      </table>
      <p v-if="!sales_return.length" class="text-center mt-5">No data</p>
    </div>
  </div>
</template>

<script setup>
import {inject} from 'vue'
import {useRoute} from 'vue-router'
import handlePurchaseAndSalesReturn from '@/services/modules/purchaseSalesReturn'
import handleCompany from '@/services/modules/company'
import printMushak67 from '@/services/utils/pdf/mushak67Pdf'

const props = defineProps({
  sales_return: Array,
})

const $route = useRoute()
const showError = inject('showError')

const {fetchSalesReturn} = handlePurchaseAndSalesReturn()
const {fetchCompanyInfo} = handleCompany()
const {exportToPdfMushak67} = printMushak67()

async function goToMushak67Print(id) {
  const companyQuery = `?company_id=${$route.params.companyId}`
  try {
    const salesReturnRes = fetchSalesReturn(id, companyQuery)
    const companyRes = fetchCompanyInfo($route.params.companyId)
    const [returnResponse, companyResponse] = await Promise.all([salesReturnRes, companyRes])
    if (!returnResponse.data) return
    exportToPdfMushak67(companyResponse.data, returnResponse.data)
  } catch (err) {
    showError('Something went wrong')
  }
}
</script>
